import { Injectable } from '@angular/core';
import { LoggingSink, LogSeverity } from '../models/logging-sink';

@Injectable({
  providedIn: 'root',
})
export class ConsoleLoggingSink implements LoggingSink {
  public log(severity: LogSeverity, timestamp: string, message: string): void {
    const string = `${timestamp} ${severity.toString()} MESSAGE: ${message}`;
    // eslint-disable-next-line no-console
    console.log(string);
  }
}
